import menu from './pt-BR/menu';
import pages from './pt-BR/pages';
import pwa from './pt-BR/pwa';

export default {
  'navBar.lang': '语言',
  ...pages,
  ...menu,
  ...pwa,
};
